export const CREATE_PHONE_CONFIRMATION = 'CREATE_PHONE_CONFIRMATION';
export const SUCCESS_CREATE_PHONE_CONFIRMATION = 'SUCCESS_CREATE_PHONE_CONFIRMATION';
export const FAILURE_CREATE_PHONE_CONFIRMATION = 'FAILURE_CREATE_PHONE_CONFIRMATION';

export const CONFIRM_PHONE = 'CONFIRM_PHONE';
export const SUCCESS_CONFIRM_PHONE = 'SUCCESS_CONFIRM_PHONE';
export const FAILURE_CONFIRM_PHONE = 'FAILURE_CONFIRM_PHONE';

export const DENY_CONFIRMATION = 'DENY_CONFIRMATION';


// WEBPACK FOOTER //
// ./js/actions/PhoneConfirmation.js